var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D9F7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.17 17.4399L22 22.5499L30.77 17.4699",
    stroke: "#4AD991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31.61V22.54",
    stroke: "#4AD991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.39 19.1701C12.39 17.7901 13.38 16.1101 14.59 15.4401L19.93 12.4701C21.07 11.8401 22.94 11.8401 24.08 12.4701L29.42 15.4401C30.63 16.1101 31.62 17.7901 31.62 19.1701V24.8201C31.62 26.2001 30.63 27.8801 29.42 28.5501L24.08 31.5201C22.94 32.1501 21.07 32.1501 19.93 31.5201L14.59 28.5501C13.38 27.8801 12.39 26.2001 12.39 24.8201V24.0001",
    stroke: "#4AD991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.2401V19.5801L20.93 16.0701L19.88 15.4701L17.51 14.1001",
    stroke: "#4AD991",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.9782c32a06dac737c9b213dc11038db2.svg";
export { ForwardRef as ReactComponent };